import Swiper from 'swiper';
const OtherHotelsSlider = {
    _jSwiper :null,
    _swiperOtherObj:'',
    init() {
        this._jSwiper = $('.jsOtherHotelsSwiper');
        if (this._jSwiper.length > 0) {
            this.initSlider();
        }
    },
    initSlider() {
        this._swiperOtherObj = new Swiper(this._jSwiper[0], {
            slidesPerView:3,
            centeredSlides: true,
            loop: true,
            spaceBetween: 30,
            autoplay: {
                delay: 2500,
                disableOnInteraction: true,
            },
            navigation: {
                nextEl: '.swiper-facilities-next',
                prevEl: '.swiper-facilities-prev',
            },
            breakpoints: {
            // when window width is >= 320px
            100: {
            slidesPerView: 2,
            spaceBetween: 20,
            },
            // when window width is >= 480px
            480: {
            slidesPerView: 3,
            spaceBetween: 30,
            },
        },
           
        });

        // $('.jsOtherHotelsSwiper').on('mouseenter', function(){
        //     console.log('stop autoplay');
        //     this._swiperOtherObj.stopAutoplay();
        //   }) ;
        //   $('.jsOtherHotelsSwiper').on('mouseleave', function(){
        //     console.log('start autoplay');
        //     this._swiperOtherObj.startAutoplay();
        //   });

        // setTimeout(function () {
        //     slider.update();
        //     // slider.updateSlides();
        // },100)
    },
}
export default OtherHotelsSlider;


// WEBPACK FOOTER //
// ./scripts/modules/components/_otherhotels-slider.js